import { render } from "./YAxisForm.vue?vue&type=template&id=f130b5f2"
import script from "./YAxisForm.vue?vue&type=script&lang=js"
export * from "./YAxisForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__